import { Toaster as SonnerToaster, type ToasterProps as SonnerToasterProps } from 'sonner'
import { CircleAlert, CircleCheck, Info, TriangleAlert } from 'lucide-react'
import { useTheme } from '../theme/ThemeProvider.tsx'
import './Toast.module.css'

export interface ToasterProps extends Omit<SonnerToasterProps, 'theme'> {
  /** Override theme instead of using Nexus ThemeProvider */
  theme?: 'dark' | 'light'
}

const icons: SonnerToasterProps['icons'] = {
  success: <CircleCheck size={16} />,
  error: <CircleAlert size={16} />,
  warning: <TriangleAlert size={16} />,
  info: <Info size={16} />,
}

const DEFAULT_DURATION = 4000

export function Toaster({
  theme: themeProp,
  position = 'bottom-right',
  closeButton = true,
  duration = DEFAULT_DURATION,
  icons: iconsProp,
  toastOptions,
  ...props
}: ToasterProps) {
  const { theme: nexusTheme } = useTheme()
  const resolvedTheme = themeProp ?? nexusTheme

  return (
    <SonnerToaster
      theme={resolvedTheme}
      position={position}
      closeButton={closeButton}
      duration={duration}
      icons={{ ...icons, ...iconsProp }}
      toastOptions={{
        ...toastOptions,
        style: {
          '--toast-duration': `${duration}ms`,
          ...toastOptions?.style,
        } as React.CSSProperties,
        classNames: {
          toast: 'nexus-toast',
          title: 'nexus-toast-title',
          description: 'nexus-toast-description',
          actionButton: 'nexus-toast-action',
          cancelButton: 'nexus-toast-cancel',
          closeButton: 'nexus-toast-close',
          ...toastOptions?.classNames,
        },
      }}
      {...props}
    />
  )
}
